export enum CmsPageType {
    ThankYouForRegistering = 100,
    CompetitorHelp = 200,
    DownloadDocsProContracts = 300,
    DownloadDocsAdmin = 400
}

export class GetCmsPageDto {
    content: string;
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/models/cms.pages/cms.pages.models.ts